export namespace ManageUser {
  const operatorLevels = ['full', 'serviceOperator', 'admin'];

  export type OperatorLevel = (typeof operatorLevels)[number];

  const operatorAssignment: Record<OperatorLevel, readonly OperatorLevel[]> = {
    full: ['limited', 'full'],
    serviceOperator: ['limited', 'full', 'serviceOperator'],
    admin: ['limited', 'full', 'serviceOperator', 'admin'],
  };

  export class OperatorManagerAccessLevel {
    constructor(private readonly _level: OperatorLevel) {}

    public assignLevels(): readonly OperatorLevel[] {
      return operatorAssignment[this._level];
    }
  }
}
